import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import {businessRoutes} from '@/router/business'
import {dataStatisticsRoutes} from '@/router/dataStatistics'
import {goodsManageRoutes} from '@/router/goodsManage'
import {revenueReportRoutes} from '@/router/revenueReport'
import {couponsRoutes} from '@/router/coupons'
import {coachManageRoutes} from '@/router/coachManage'
import {accountManageRoutes} from '@/router/accountManage'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: '/login'
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: "登录",
    },
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/",
    name: "home",
    component: Home,
    children: [
        ...businessRoutes,
        ...dataStatisticsRoutes,
        ...goodsManageRoutes,
        ...revenueReportRoutes,
        ...couponsRoutes,
        ...coachManageRoutes,
        ...accountManageRoutes
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
